import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "icon-setting",
  "use": "icon-setting-usage",
  "viewBox": "0 0 1024 1024",
  "content": "<symbol class=\"icon\" viewBox=\"0 0 1024 1024\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" id=\"icon-setting\"><defs><style type=\"text/css\"></style></defs><path d=\"M424.763392 689.588224l259.528704-259.524608c73.37984 37.507072 165.515264 25.591808 226.932736-35.823616 61.417472-61.41952 73.332736-153.552896 35.825664-226.934784l-168.658944 168.656896-85.05344-85.055488 168.654848-168.656896c-73.37984-37.50912-165.515264-25.593856-226.932736 35.823616-61.417472 61.417472-73.332736 153.552896-35.825664 226.934784L339.707904 604.532736c-73.37984-37.507072-165.515264-25.591808-226.932736 35.823616C51.359744 701.771776 39.44448 793.9072 76.949504 867.291136l168.656896-168.656896 85.057536 85.055488-168.656896 168.656896c73.383936 37.505024 165.517312 25.591808 226.936832-35.827712C450.357248 855.103488 462.27456 762.97216 424.763392 689.588224z\" p-id=\"2163\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/icons/svg/setting.svg
// module id = Kttn
// module chunks = 132